import React from 'react';
import { Card, CardBody } from '@spark/ui-components/components/Card';
import { useBeneficiosNavegacao } from '../hooks';
import { useBeneficiosListagem } from '../hooks';
import BeneficiosHeader from './BeneficiosHeader';
import BeneficiosTable from './BeneficiosTable';
import BeneficiosFilter from './BeneficiosFilter';

const BeneficiosCard = ({
  id,
  showActions = true,
  enableRowClick = true,
  showFilter = true,
  showHeader = true
}) => {
  const {
    data,
    loading,
    filterLoading,
    totalRegistros,
    paginaAtual,
    quantidadePorPagina,
    handleFilterApply,
    handleLimparFiltros,
    handleExcluir,
    setPaginaAtual,
    setQuantidadePorPagina
  } = useBeneficiosListagem(id);
  const {
    handleRowClick,
    handleAdicionar,
    handleEditar
  } = useBeneficiosNavegacao();
  return <>
    <Card>
      <CardBody>
        {showHeader && <BeneficiosHeader totalRegistros={totalRegistros} onAdicionar={showActions ? handleAdicionar : undefined} />}

        {showFilter && <BeneficiosFilter loading={filterLoading} onApply={handleFilterApply} onLimpar={handleLimparFiltros} />}

        <BeneficiosTable
          data={data}
          loading={loading}
          onRowClick={enableRowClick ? handleRowClick : undefined}
          onEditar={showActions ? handleEditar : undefined}
          onExcluir={showActions ? handleExcluir : undefined}
          manualPagination={true}
          totalRegistros={totalRegistros}
          controlledPagination={
            {
              pageIndex: Math.max(0, (paginaAtual || 1) - 1),
              pageSize: quantidadePorPagina || 10
            }
          } 
          onPaginationChange={next => {
            if (next && typeof next.pageSize === 'number') setQuantidadePorPagina(next.pageSize);
            if (next && typeof next.pageIndex === 'number') setPaginaAtual(next.pageIndex + 1);
          }} />
      </CardBody>
    </Card>
  </>;
};

export default BeneficiosCard;
